import {z} from 'zod';

import i18n from '@dms/i18n';

const MINIMUM_VALUE = 0;

export const BankTransferSettingsFormSchema = z.object({
  invoiceMaturity: z
    .number({
      required_error: i18n.t('general.validations.fieldIsRequired'),
      invalid_type_error: i18n.t('general.validations.fieldIsRequired'),
    })
    .min(MINIMUM_VALUE, i18n.t('general.validations.minValue', {min: MINIMUM_VALUE}))
    .int(i18n.t('general.errors.number.integer')),
  paymentLimit: z
    .number({
      required_error: i18n.t('general.validations.fieldIsRequired'),
      invalid_type_error: i18n.t('general.validations.fieldIsRequired'),
    })
    .min(MINIMUM_VALUE, i18n.t('general.validations.minValue', {min: MINIMUM_VALUE})),
});

export type BankTransferSettingsFormValues = z.infer<typeof BankTransferSettingsFormSchema>;
